const seedPacketOpeningAssetRoot = "/assets/seed-packet-opening";
const paperReferenceAssetRoot = "/assets/paper-reference";
const croppedPaperReferenceAssetRoot = `${paperReferenceAssetRoot}/cropped`;
const selectedRowAssetRoot = `${paperReferenceAssetRoot}/selected-row`;
const gardenAssetRoot = "/assets/garden";
const storeBadgeAssetRoot = "/assets/store-badges";

export const landingPageAssets = {
  audio: {
    backgroundMusic: `${seedPacketOpeningAssetRoot}/audio/glockenspiel-grammar.mp3`,
    backgroundMusicMobile: `${seedPacketOpeningAssetRoot}/audio/glockenspiel-grammar-mobile.mp3`,
    reveal: `${seedPacketOpeningAssetRoot}/audio/uncommon-reveal-timed.m4a`,
    tapOne: `${seedPacketOpeningAssetRoot}/audio/tap-1.m4a`,
    tapTwo: `${seedPacketOpeningAssetRoot}/audio/tap-2.m4a`,
    uiHover: `${seedPacketOpeningAssetRoot}/audio/ui-hover.mp3`,
  },
  packet: {
    model: `${seedPacketOpeningAssetRoot}/themes/flower_garden/packet-final.glb`,
    particle: `${seedPacketOpeningAssetRoot}/themes/flower_garden/particle.png`,
    sprite: `${paperReferenceAssetRoot}/7SH33HWV8CNF13305ZEVJG88RT.png`,
  },
  paper: {
    logo: `${paperReferenceAssetRoot}/sky-garden-logo.svg`,
  },
  reveal: {
    flowerPack: `${croppedPaperReferenceAssetRoot}/flower-pack-pose.png`,
    garden: `${gardenAssetRoot}/garden-prototype.png`,
    selectedRow: {
      doubleYellowQuestion: `${selectedRowAssetRoot}/double-yellow-question.png`,
      legendaryQuestion: `${selectedRowAssetRoot}/legendary-question-mark.svg?v=crisp-2`,
      legendaryStar: `${selectedRowAssetRoot}/legendary-star-group.svg`,
      plantBlueQuestion: `${selectedRowAssetRoot}/plant-blue-question.png`,
      plantSilhouetteQuestion: `${selectedRowAssetRoot}/plant-silhouette-question.png`,
      signQuestion: `${selectedRowAssetRoot}/sign-question.png`,
    },
    treePack: `${croppedPaperReferenceAssetRoot}/tree-pack.png`,
  },
  storeBadges: {
    appStore: `${storeBadgeAssetRoot}/download-on-the-app-store.svg`,
    googlePlay: `${storeBadgeAssetRoot}/get-it-on-google-play.png`,
  },
} as const;
